
<template>
  <div class="container-fluid mt-1 p-0">
    <div class="row">
      <div class="col-12 custom-form-label">
        Add series to diagram
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-1">
        <input-select3 class="mt-1" v-model="el.TypeName" v-bind:options="['Avg','Group','Count']" />
        <input-select3 class="ml-1 mt-1" v-model="el.Source" v-bind:options="['Priority','Time','User']" />
        <input type="text" class="form-control ml-1 px-1 col-4" v-model="el.Name" style="display:inline-table;font-size:12px;line-height:20px;height:38px;" />
        <input-color-selector v-model="el.Color"></input-color-selector>
        <a class="ml-1 mt-1" href="#" @click="add(el)"><i class="icon-add"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'series-add',
    components: {
    },
    data(){
      return {
        el: {}
      }
    },
    props: {
      value: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      list: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
    },
    methods: {
      add(el) {
        var elementToAdd = JSON.parse(JSON.stringify(el));
        this.$emit("add", elementToAdd)
        this.el = {};
      },
      setData(data) {
        this.value = data;
      },
      
    },
  created() {

  },
  mounted() {

  },
    computed: {
      
      realValue() {
        return this.value != null ? this.value : this.list;
      },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/statistics/series-add.vue